module.exports = __webpack_public_path__ + "static/media/close-light.0f64e507.svg";